'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$64() {
  this.aHZ = null;
  this.aHX = null;
  this.aHY = false;
  this.aHV = null;
  this.aHW = false;
  this.aI0 = false;
  this.aI1 = false;
  this.aHZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$64 as $c_Lpresto_CredentialsView$$anon$64 };
$p = $c_Lpresto_CredentialsView$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$64;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$64() {
}
export { $h_Lpresto_CredentialsView$$anon$64 as $h_Lpresto_CredentialsView$$anon$64 };
$h_Lpresto_CredentialsView$$anon$64.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHZ;
});
$p.t = (function() {
  if ((!this.aHY)) {
    this.aHX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHY = true;
  }
  return this.aHX;
});
$p.ag = (function() {
  if ((!this.aHW)) {
    this.aHV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vn(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHW = true;
  }
  return this.aHV;
});
$p.v = (function() {
  if ((!this.aI1)) {
    this.aI0 = false;
    this.aI1 = true;
  }
  return this.aI0;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$64, "presto.CredentialsView$$anon$64", ({
  Gd: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$64 as $d_Lpresto_CredentialsView$$anon$64 };
//# sourceMappingURL=presto.-Credentials-View$$anon$64.js.map
